import { message } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component, createRef } from 'react'
import { CASE_CONTENT_IMAGE_LIMIT } from '../../../constants'
import CaseContentItem from '../components/CaseContentItem'
import Operate from './operate'
import PictureDragPanel from './PictureDragPanel'
import style from './style.module.less'
import TitleEditor from './TitleEditor'
import UninoPhoto from './UnionPhoto'
import UnionPhotoEdit from './unionPhotoEdit'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.modalRef = createRef()
  }

  handleChangePosition = () => {
    setTimeout(() => {
      const el = document.querySelector('#case-edit')
      const titleEl = document.getElementById('static-title-content')
      if (titleEl) {
        el.style.marginTop = `${titleEl.offsetTop - 52}px`
      }
    }, 0)
  }

  handleChangeScroll = () => {
    setTimeout(() => {
      this.modalRef.current.scroll(0, this.modalRef.current.scrollHeight)
    }, 0)
  }

  handleChangeScrollAndPosition = () => {
    this.handleChangeScroll()
    this.handleChangePosition()
  }

  submitCaseContent = () => {
    const {
      tempCaseContent,
      textNum,
      imgNum,
      videoNum,
      caseContentTextLimit
    } = this.props.store

    const haveVideo = tempCaseContent.some(el => el.type == 'video')
    const titleList = tempCaseContent.filter(el => el.type == 'title')
    const haveTitle =
      titleList.length && titleList.every(item => item.text || item.title)
    const imageLength = tempCaseContent.filter(el => el.type == 'img').length

    if (!haveVideo && imageLength < 5) {
      message.warning('图片至少上传5张')
      return
    }

    if (CASE_CONTENT_IMAGE_LIMIT < imgNum) {
      message.warning('图片数量超出限制,请修改')
      return
    }

    if (caseContentTextLimit < textNum) {
      message.warning('文字数量超出限制,请修改')
      return
    }

    if (videoNum > 3) {
      message.warning('视频数量超出限制,请修改')
      return
    }

    if (titleList.length > 0 && !haveTitle) {
      message.warning('标题和描述至少填写一项')
      return
    }

    this.props.onSubmit(tempCaseContent.map(({ active, ...rest }) => rest))()
  }

  render() {
    const { _meal_type, store } = this.props
    const {
      tempCaseContent,
      replaceCaseContentImage,
      showTitleEditor,
      changeActiveCase,
      moveUpCaseContent,
      moveDownCaseContent,
      deleteCaseContent,
      copyCaseContent,
      addCaseContentImageTitle,
      caseContentTitleStatus,
      replaceCaseContentVideo,
      isShowKeZhao,
      isShowkeZhaoItem,
      property_id
    } = store
    const editable = true

    return (
      <>
        <div className={style.wrapper}>
          <div className={style.container}>
            <img
              src="https://qnm.hunliji.com/camel-13a7b367-dd6c-4194-b725-6b5931bf209d.png"
              style={{ width: 360, height: 60 }}
            />
            <div className={style.info} ref={this.modalRef} id="content_info">
              <div className={style.wapper}>
                {isShowkeZhaoItem &&
                  _meal_type != 2 &&
                  property_id == 6 && <UninoPhoto store={this.props.store} />}
                {tempCaseContent.length != 0 &&
                  tempCaseContent.map((item, i) => (
                    <CaseContentItem
                      key={i}
                      index={i}
                      maxLength={tempCaseContent.length}
                      item={item}
                      editable={editable}
                      replaceCaseContentImage={replaceCaseContentImage}
                      replaceCaseContentVideo={replaceCaseContentVideo}
                      showTitleEditor={showTitleEditor}
                      onClick={index =>
                        changeActiveCase(index, this.handleChangePosition)
                      }
                      onMoveUp={moveUpCaseContent(i)}
                      onMoveDown={moveDownCaseContent(i)}
                      onDelete={deleteCaseContent(i)}
                      onCopy={copyCaseContent(i, this.handleChangePosition)}
                      onAddText={addCaseContentImageTitle(i)}
                    />
                  ))}
              </div>
              <div
                className={style.editArea}
                id="case-edit"
                style={{
                  zIndex: caseContentTitleStatus || isShowKeZhao ? 9 : 1,
                  marginLeft: isShowKeZhao ? '10px' : '60px',
                  width: isShowKeZhao ? '330px' : '290px'
                }}
              >
                {isShowKeZhao && <UnionPhotoEdit store={this.props.store} />}
                {caseContentTitleStatus && (
                  <TitleEditor
                    store={this.props.store}
                    active={tempCaseContent.find(el => el.active)}
                  />
                )}
              </div>
            </div>
            <Operate
              store={this.props.store}
              _meal_type={_meal_type}
              handleChangeScrollAndPosition={this.handleChangeScrollAndPosition}
            />
          </div>
        </div>
        <PictureDragPanel
          store={this.props.store}
          onSubmit={this.handleChangeScroll}
        />
      </>
    )
  }
}
